import React, { useState, useEffect, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.scss';
import FlexTable from './components/FlexTable';
import Footer from './components/Footer';
import SearchBox from './components/SearchBox';
import { tableData } from './data/data';
import useStickyHeader from './hooks/useStickyHeader';

function App() {
  // data state management
  const [searchValue, setSearchValue] = useState('');
  const headerHidden = useStickyHeader();

  // filter data based on search input
  const filteredData = useMemo(() => {
    return tableData.filter(
      (row) =>
        row.name?.toLowerCase().includes(searchValue.toLowerCase()) ||
        row.date?.toLowerCase().includes(searchValue.toLowerCase()) ||
        row.location?.toLowerCase().includes(searchValue.toLowerCase()) ||
        (row.distance !== undefined &&
          String(row.distance)
            .toLowerCase()
            .includes(searchValue.toLowerCase())) ||
        (row.rating !== undefined &&
          String(row.rating).toLowerCase().includes(searchValue.toLowerCase()))
    );
  }, [searchValue]);

  // handle search input changes
  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  // console message on mount
  useEffect(() => {
    console.log(
      'Step by step, trail by trail, finding peace in the wild. 🌲👣'
    );
  }, []);

  return (
    <main className="main">
      <div className="main-container">
        <header className={`sticky-header ${headerHidden ? 'hidden' : ''}`}>
          <div className="header">
            <div className="index">
              hikes.fidacura.net: a personal archive of favourite hikes.
            </div>
          </div>
          <div className="search">
            <SearchBox value={searchValue} onChange={handleSearchChange} />
          </div>
        </header>
        <FlexTable data={filteredData} />
        <Footer />
      </div>
    </main>
  );
}

// render app to dom
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
} else {
  console.error('Root container not found');
}
